import { getOrderData, OrderData } from 'api/dashboard/_request';
import EcomReturningCustomerRateChart from 'components/charts/e-charts/EcomReturningCustomerRateChart';
import React, { useEffect, useState } from 'react';
import { Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

type RangeType = 'today' | 'week' | 'month' | 'year';

const PRESET_RANGES: { label: string; value: RangeType }[] = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'week' },
  { label: 'This Month', value: 'month' },
  { label: 'This Year', value: 'year' }
];

const EcomReturningCustomerRate = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const id = user?._id;
  const [range, setRange] = useState<RangeType>('year');
  const [orderData, setOrderData] = useState<OrderData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const params = { range, id };
      try {
        const data = await getOrderData(params);
        setOrderData(data || []);
      } catch (error) {
        console.error('Failed to fetch product data:', error);
      }
    };
    fetchData();
  }, [range]);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between">
          <div>
            <h3>Returning customer rate</h3>
            <h6 className="text-body-tertiary">Last {range}</h6>
            <p className="mb-1 text-body-tertiary">
              Rate of customers returning to your shop over time
            </p>
            <h4>{orderData.length ?? 0}</h4>
          </div>
          <Col xs={8} sm={4}>
            <Form.Select
              size="sm"
              value={range}
              onChange={e => setRange(e.target.value as RangeType)}
            >
              {PRESET_RANGES.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </Form.Select>
          </Col>
        </div>
      </div>
      <EcomReturningCustomerRateChart data={orderData} range={range} />
    </>
  );
};

export default EcomReturningCustomerRate;
